"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyRounding = applyRounding;
exports.correctRoundedDate = correctRoundedDate;
exports.getStartFinal = getStartFinal;
exports.getEndFinal = getEndFinal;
exports.applyAutoMeals = applyAutoMeals;
exports.applyAutoBreaks = applyAutoBreaks;
exports.getResultBreakDown = getResultBreakDown;
exports.getAvailableActions = getAvailableActions;
exports.getCommonWorkDays = getCommonWorkDays;
const model_1 = require("./model");
const utils_1 = require("./utils");
const openapi_1 = require("@pentacode/openapi");
const breaks_1 = require("./breaks");
const interval_1 = require("./time/interval");
const consts_1 = require("./time/consts");
const time_result_1 = require("./time/time-result");
__exportStar(require("./time/consts"), exports);
__exportStar(require("./time/interval"), exports);
__exportStar(require("./time/date-range"), exports);
__exportStar(require("./time/time-result"), exports);
__exportStar(require("./time/balances"), exports);
__exportStar(require("./time/nominals"), exports);
__exportStar(require("./time/daily-results"), exports);
/**
 * Mutates the given date by applying rounding to the minutes.
 *
 * If `rounding` is positive, the date is rounded up, if negative, it is rounded down.
 *
 * The date is also rounded down to the full minute.
 *
 * @param date The date to apply rounding to
 * @param rounding The rounding to apply in Minutes
 */
function applyRounding(date, rounding) {
    if (rounding) {
        const minutes = date.getMinutes();
        // Minutes subtracted to round down
        const deltaRoundDown = minutes % rounding;
        // If rounding is positive, rounding is added to round up
        const deltaRoundUp = Math.max(0, rounding);
        // apply roundings
        date.setMinutes(minutes - deltaRoundDown + deltaRoundUp);
    }
    // Round to full minute
    date.setSeconds(0);
    date.setMilliseconds(0);
}
/**
 * Corrects to `plannedDate` if `date` was logged before `plannedDate` but rounded up beyond it
 * or if it was logged after plannedDate, but rounded down to earlier than it
 * @param date The date to be corrected
 * @param loggedTime The date `date` was logged
 * @param plannedDate The date that `date` should be corrected to
 * @returns Copy of `plannedDate` if correction is neccessary, otherwise `date`
 */
function correctRoundedDate(date, loggedTime, plannedDate) {
    if (!plannedDate)
        return date;
    if ((loggedTime <= plannedDate && date > plannedDate) || (loggedTime >= plannedDate && date < plannedDate)) {
        return new Date(plannedDate);
    }
    return date;
}
function getStartFinal(timeEntry, loggedTime, useActualTimeAtShiftStart, shiftStartRounding) {
    // If logged time is earlier than planned and useActualTimeAtShiftStart setting
    // is not set, use planned time instead
    let startFinal = timeEntry.startPlanned && loggedTime < timeEntry.startPlanned && !useActualTimeAtShiftStart
        ? new Date(timeEntry.startPlanned)
        : new Date(loggedTime);
    applyRounding(startFinal, shiftStartRounding);
    startFinal = correctRoundedDate(startFinal, loggedTime, timeEntry.startPlanned);
    return startFinal;
}
function getEndFinal(timeEntry, loggedTime, useActualTimeAtShiftEnd, shiftEndRounding) {
    // If logged time is later than planned and useActualTimeAtShiftEnd setting
    // is not set, use planned time instead
    let endFinal = timeEntry.endPlanned && loggedTime > timeEntry.endPlanned && !useActualTimeAtShiftEnd
        ? new Date(timeEntry.endPlanned)
        : new Date(loggedTime);
    applyRounding(endFinal, shiftEndRounding);
    endFinal = correctRoundedDate(endFinal, loggedTime, timeEntry.endPlanned);
    // Make sure end time is not earlier than start time
    if (timeEntry.startFinal && endFinal < timeEntry.startFinal) {
        endFinal = timeEntry.startFinal;
    }
    return endFinal;
}
function applyAutoMeals(company, timeEntry, { breakfast, lunch, dinner }) {
    const timeSettings = company.getTimeSettings({ timeEntry });
    if (timeSettings.mealsMode !== model_1.MealsMode.Auto ||
        !timeEntry.final ||
        timeEntry.durationFinal < timeSettings.mealsMinDuration) {
        return;
    }
    const breakfastInterval = timeSettings.mealEnabledBreakfast &&
        timeSettings.mealStartBreakfast &&
        timeSettings.mealEndBreakfast &&
        (0, utils_1.parseTimes)(timeEntry.date, timeSettings.mealStartBreakfast, timeSettings.mealEndBreakfast);
    const lunchInterval = timeSettings.mealEnabledLunch &&
        timeSettings.mealStartLunch &&
        timeSettings.mealEndLunch &&
        (0, utils_1.parseTimes)(timeEntry.date, timeSettings.mealStartLunch, timeSettings.mealEndLunch);
    const dinnerInterval = timeSettings.mealEnabledDinner &&
        timeSettings.mealStartDinner &&
        timeSettings.mealEndDinner &&
        (0, utils_1.parseTimes)(timeEntry.date, timeSettings.mealStartDinner, timeSettings.mealEndDinner);
    if (breakfastInterval && breakfast && (0, interval_1.overlap)(timeEntry.final, [breakfastInterval])) {
        timeEntry.mealsBreakfast = 1;
    }
    if (dinnerInterval && dinner && (0, interval_1.overlap)(timeEntry.final, [dinnerInterval])) {
        timeEntry.mealsDinner = 1;
    }
    if (lunchInterval && lunch && (0, interval_1.overlap)(timeEntry.final, [lunchInterval])) {
        timeEntry.mealsLunch = 1;
    }
}
function applyAutoBreaks(entry, breakMode, autoBreaks) {
    var _a;
    const breakAuto = [model_1.BreakMode.Planned, model_1.BreakMode.PlannedPlusManual, model_1.BreakMode.PlannedOrManual].includes(breakMode)
        ? entry.breakPlanned || 0
        : (0, breaks_1.getAutomaticBreak)(entry.durationFinal, { autoBreaks, breakMode });
    const prevBreak = entry.break || 0;
    const breakLogged = entry.breakLogged || 0;
    if (entry.break === null || breakAuto !== entry.breakAuto) {
        const prevBreakAuto = (_a = entry.breakAuto) !== null && _a !== void 0 ? _a : breakAuto;
        entry.breakAuto = breakAuto;
        const brk = [model_1.BreakMode.AutoOrManual, model_1.BreakMode.PlannedOrManual].includes(breakMode)
            ? (0, openapi_1.max)(breakAuto, breakLogged)
            : (0, openapi_1.add)(breakAuto, breakLogged);
        const prevBreakAutoWithManual = [model_1.BreakMode.AutoOrManual, model_1.BreakMode.PlannedOrManual].includes(breakMode)
            ? (0, openapi_1.max)(prevBreakAuto, breakLogged)
            : (0, openapi_1.add)(prevBreakAuto, breakLogged);
        // If break is null or hasn't been edited after the fact, update value
        if (entry.break === null || prevBreak - prevBreakAutoWithManual * 60 < 1) {
            entry.break = brk;
        }
    }
}
function getResultBreakDown(company, timeEntries) {
    timeEntries = timeEntries.filter((e) => e.type !== model_1.TimeEntryType.VacationAdjustment && Boolean(e.result));
    const breakdown = {
        items: [],
        total: (0, time_result_1.getTotalResults)(timeEntries.filter((e) => Boolean(e.result)).map((entry) => entry.result)),
    };
    const items = new Map();
    for (const { type, positionId, result, comment } of timeEntries) {
        if (!result) {
            continue;
        }
        const key = [model_1.TimeEntryType.HourAdjustment, model_1.TimeEntryType.VacationAdjustment].includes(type)
            ? `${type}_${positionId}_${comment}`
            : `${type}_${positionId}`;
        const existing = items.get(key);
        if (existing) {
            existing.result = (0, time_result_1.addTimeResults)(existing.result, result);
        }
        else {
            const workArea = (positionId && company.getPosition(positionId)) || null;
            items.set(key, {
                type,
                result,
                workArea,
                comment: [model_1.TimeEntryType.HourAdjustment, model_1.TimeEntryType.VacationAdjustment].includes(type)
                    ? comment
                    : undefined,
            });
        }
    }
    breakdown.items = [...items.values()];
    return breakdown;
}
function getAvailableActions(timeEntry, settings) {
    const startString = timeEntry.startFinal || timeEntry.startPlanned || new Date();
    const startTime = new Date(startString).getTime();
    const canStart = startTime - settings.allowEarlyStart * consts_1.hour < Date.now();
    const isUnlocked = Date.now() < startTime + settings.lockAfter * consts_1.hour;
    const shiftReady = canStart && isUnlocked;
    // Can't do anything if shift is not ready
    if (!shiftReady)
        return [];
    // If paused, can end the break or the shift
    if (timeEntry.status === "paused") {
        return ["endBreak", "endShift"];
    }
    // If ongoing, can end the shift or start a break if allowed
    if (timeEntry.status === "ongoing") {
        if (settings.manualBreaksAllowed) {
            return ["startBreak", "endShift"];
        }
        return ["endShift"];
    }
    // If scheduled, can start the shift
    if (timeEntry.status === "scheduled") {
        return ["startShift"];
    }
    // Default (e.g completed), can't do anything
    return [];
}
function getCommonWorkDays(dailyResults) {
    const daysPerWeekDay = [0, 0, 0, 0, 0, 0, 0];
    const daysPerWeek = new Map();
    for (const dailyResult of dailyResults) {
        const isWorkOrAbsenceDay = dailyResult.results.work.base.duration > 0 || dailyResult.results.absences.base.duration > 0;
        const weekDay = new Date(dailyResult.date).getDay();
        if (isWorkOrAbsenceDay) {
            daysPerWeekDay[weekDay]++;
            const week = `${(0, utils_1.parseDateString)(dailyResult.date).getFullYear()},${(0, utils_1.getWeekNumber)(dailyResult.date)}`;
            daysPerWeek.set(week, (daysPerWeek.get(week) || 0) + 1);
        }
    }
    const daysPerWeekArr = Array.from(daysPerWeek.values());
    const totaldays = daysPerWeekArr.reduce((a, b) => a + b, 0);
    const weeksWorked = daysPerWeekArr.filter((val) => val > 0).length;
    const averageDaysPerWeek = Math.round(totaldays / weeksWorked);
    const commonWorkDays = daysPerWeekDay
        .map((count, i) => [count, i])
        .sort(([a], [b]) => b - a)
        .slice(0, averageDaysPerWeek)
        .map(([, i]) => i);
    return commonWorkDays;
}
//# sourceMappingURL=time.js.map